import { render, staticRenderFns } from "./topo-aside.vue?vue&type=template&id=547b9c9b&"
import script from "./topo-aside.vue?vue&type=script&lang=ts&"
export * from "./topo-aside.vue?vue&type=script&lang=ts&"
import style0 from "./topo-aside.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports